/** Rodné číslo, "123456/1234" (older ones have 3 digits after the slash). */
export const ID_PATTERN = /^[0-9]{6}\/[0-9]{3,4}$/
export const PASSPORT_PATTERN = /^[A-Z0-9]{6,9}$/

/** Digits only, with the slash inserted after the sixth one. */
export function formatIdNumber(raw: string) {
  const digits = raw.replace(/\D/g, '')
  return digits.length > 6 ? digits.slice(0, 6) + '/' + digits.slice(6) : digits
}
